import {
  Box,
  Flex,
  Image,
  Text,
  SimpleGrid,
  GridItem,
  Heading,
  HStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/ui/button";
import { Header } from "../components/Header";
import { SEO } from "../components/SEO";
import StructuredData from "../components/SEO/StructuredData";

import HeroImage from "../assets/images/heroImage.png";

export const Home = () => {
  const navigate = useNavigate();

  return (
    <Box h={{ base: "auto", lg: "100vh" }} overflow={"hidden"}>
      <SEO 
        title="Udobong Ntia | Oil & Gas Executive | Energy Leader"
        description="A purpose-driven leader dedicated to empowering future generations and driving sustainable economic growth in the energy sector."
        canonicalUrl="https://udobongntia.com/"
        keywords={['Udobong Ntia', 'Oil and Gas Executive', 'Energy Leader', 'ExxonMobil', 'Petroleum Industry', 'Business Development', 'NNPC']}
      />
      <StructuredData type="Person" />
      <Header />

      <SimpleGrid columns={{ base: 1, lg: 2 }}>
        <GridItem
          pb={{ base: "32px", lg: "auto" }}
          pt={{ base: "115px", lg: "auto" }}
        >
          <Flex
            flexDir={"column"}
            justify={"center"}
            align={{ base: "center", lg: "flex-start" }}
            h={"100%"}
            px={{ base: "16px", lg: "68px" }}
            gap={"16px"}
          >
            <Heading
              fontSize={{ base: "28px", lg: "46px" }}
              color={"#101720"}
              lineHeight={"120%"}
              textAlign={{ base: "center", lg: "left" }}
              fontFamily={"BricolageGrotesque"}
              fontWeight={600}
            >
              Udy Ntia. Oil & Gas Executive. Energy Leader. Mentor.
            </Heading>

            <Text
              fontFamily={"Raleway"}
              fontSize={{ base: "16px", lg: "19px" }}
              color={"#667085"}
              fontWeight={500}
              textAlign={{ base: "center", lg: "left" }}
            >
              A purpose-driven leader dedicated to empowering future generations
              and driving sustainable economic growth.{" "}
            </Text>

            <HStack gap={"16px"}>
              <Button onClick={() => navigate("/about")}>Profile</Button>

              <Button
                opaque={false}
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/udobong-ntia-b171871?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
                    "_blank"
                  )
                }
              >
                LinkedIn
              </Button>
            </HStack>
          </Flex>
        </GridItem>

        <GridItem>
          <Image
            src={HeroImage}
            alt="Udobong Ntia - Oil & Gas Executive and Energy Leader"
            objectFit={"cover"}
            h={{ base: "auto", lg: "100vh" }}
            w="100%"
          />
        </GridItem>
      </SimpleGrid>
    </Box>
  );
};
